'use client';

import Header from '@/components/common/Header';
import StatsOverview from './components/StatsOverview';
import PerformanceChart from './components/PerformanceChart';
import ActiveDealsSection from './components/ActiveDealsSection';
import LiveMetrics from './components/LiveMetrics';
import Icon from '@/components/ui/AppIcon';
import { useRouter } from 'next/navigation';
import { useLanguage } from '@/contexts/LanguageContext';

export default function LivePerformanceDashboardPage() {
  const router = useRouter();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/assets/images/man_handing_money_to_girl_background.png')" }}>
      <div className="min-h-screen bg-slate-900/80 backdrop-blur-sm">
      <Header />

      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="mb-12">
            <div className="flex items-center space-x-3 mb-4">
              <div className="p-3 bg-accent/10 rounded-lg">
                <Icon name="ChartBarIcon" size={32} variant="solid" className="text-accent" />
              </div>
              <div>
                <h1 className="text-4xl md:text-5xl font-heading font-bold text-lime-500">
                  {t('home.heroTitle')}
                </h1>
                <p className="text-lg mt-2 text-slate-300">
                  {t('home.heroSubtitle')}
                </p>
              </div>
            </div>
            <p className="leading-relaxed max-w-3xl text-green-500">
              {t('home.heroDescription')}
            </p>
          </div>

          {/* Get Started CTA Box */}
          <div className="mb-8">
            <div className="bg-gradient-to-r from-lime-500/10 to-green-500/10 border-2 border-lime-500/30 rounded-xl p-4 text-center">
              <button 
                onClick={() => router?.push('/daily-deals-completed')}
                className="bg-lime-500 hover:bg-lime-600 text-slate-900 font-bold text-base px-6 py-2.5 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-lime-500/50"
              >
                {t('home.getStartedButton')}
              </button>
              <p className="mt-2 text-slate-200 text-sm font-medium">
                {t('home.getStartedSubtext')}
              </p>
            </div>
          </div>

          {/* Live Metrics Banner */}
          <div className="mb-8">
            <LiveMetrics />
          </div>

          {/* Stats Overview */}
          <div className="mb-12">
            <StatsOverview />
          </div>

          {/* Performance Chart */}
          <div className="mb-12">
            <PerformanceChart />
          </div>

          {/* Active Deals Section */}
          <div className="mb-12">
            <ActiveDealsSection />
          </div>

          {/* Real-time Update Indicator */}
          <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span>{t('common.liveData')}</span>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-card border-t border-border py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date()?.getFullYear()} Inversión Rápida. {t('common.allRightsReserved')}
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {t('common.privacyPolicy')}
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {t('common.termsOfService')}
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {t('common.contact')}
              </a>
            </div>
          </div>
        </div>
      </footer>
      </div>
    </div>
  );
}